import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  handleClick(event) {
    event.preventDefault()
    const url = this.element.dataset.url
    window.open(url, '_blank', 'noopener,noreferrer')
  }
} 